import { render, staticRenderFns } from "./moreLinksDialog.vue?vue&type=template&id=eef52ef4"
import script from "./moreLinksDialog.vue?vue&type=script&lang=js"
export * from "./moreLinksDialog.vue?vue&type=script&lang=js"
import style0 from "./moreLinksDialog.vue?vue&type=style&index=0&id=eef52ef4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports